export const INDEX_NAVIGATION_HEIGHT = 52
export const NAVBAR_HEIGHT = 76
